import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function SpeedMeter(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 1c6.065 0 11 4.935 11 11s-4.935 11-11 11S1 18.065 1 12 5.935 1 12 1zm0 15.686a8.902 8.902 0 00-5.844 2.154A8.962 8.962 0 0012 21c2.228 0 4.27-.814 5.844-2.16A8.896 8.896 0 0012 16.686zm0 .968a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM12 3c-4.962 0-9 4.037-9 9 0 2.017.666 3.88 1.79 5.382a11.046 11.046 0 016.58-2.678l2.4-4.818a1 1 0 011.791.891l-2.002 4.021c2.084.301 4.055 1.2 5.651 2.582A8.943 8.943 0 0021 12c0-4.963-4.037-9-9-9zm0 1c4.123 0 7.625 3.217 7.971 7.323a.999.999 0 01-.912 1.08c-.545.069-1.034-.361-1.08-.912C17.718 8.413 15.091 6 12 6c-3.093 0-5.719 2.412-5.979 5.492a1 1 0 11-1.993-.168C4.375 7.218 7.876 4 12 4z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoSpeedMeter = React.memo(SpeedMeter);
export default MemoSpeedMeter;